import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ICategoriaEvento, INota, TipoNota } from 'modelos/src';

import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';

import { firstValueFrom, Subscription } from 'rxjs';
import { HelperService } from '../../../../../../auxiliares/servicios/helper.service';
import { Lista2Service } from '../../../../../../auxiliares/servicios/lista2.service';

@Component({
  selector: 'app-crear-editar-nota-alarma-completo',
  templateUrl: './crear-editar-nota-alarma-completo.component.html',
  styleUrl: './crear-editar-nota-alarma-completo.component.scss',
  standalone: false,
})
export class CrearNotaAlarmaCompletoComponent implements OnInit {
  data = inject<{
    form?: FormGroup;
    tipo: TipoNota;
    nuevo: boolean;
}>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<CrearNotaAlarmaCompletoComponent>>(MatDialogRef);
  helper = inject(HelperService);
  dialog = inject(MatDialog);
  private lista2 = inject(Lista2Service);

  //DEMAS
  public loading = false;
  public id?: string;
  public idEntidad?: string;

  public tipo?: TipoNota;
  public tipoAsignado?: string;
  public form?: FormGroup;
  public title?: string;
  public editar: boolean = false;
  public nota?: INota;
  public totalCount?: number;

  public contacto?: boolean = false;
  public usuario?: boolean = false;

  //Categoría de evento a la que aplica esta nota/contacto
  public categoriasEvento: ICategoriaEvento[] = [];

  //Subss
  public notas$: Subscription;

  public tiposNota: TipoNota[] = ['Nota', 'Contacto'];

  private async listarCategoriasEvento(): Promise<void> {
    try {
      const data = await firstValueFrom(this.lista2.categoriaEventos({}));
      this.categoriasEvento = data.datos.filter(
        (c) => !c.modulo || c.modulo === 'Alarma',
      );
    } catch (error) {
      console.error('Error cargando categorías de evento:', error);
      this.categoriasEvento = [];
    }
  }

  public getPermanente() {
    return this.form?.value?.permanente;
  }

  get informacion() {
    return this.form?.get('informacion') as FormGroup;
  }

  private createForm() {
    const tipoNota = this.nota?.tipo || this.data?.tipo || '';

    this.form = new FormGroup({
      nuevo: new FormControl(this.data?.nuevo),
      orden: new FormControl(this.nota?.orden, [
        Validators.required,
        Validators.pattern('^[0-9]*$'), // Solo números
      ]),
      idAsignado: new FormControl(this.nota?.idAsignado || this.idEntidad),
      permanente: new FormControl(
        this.nota?.permanente === false ? false : true,
      ),
      vigenciaDesde: new FormControl(this.nota?.vigenciaDesde),
      vigenciaHasta: new FormControl(this.nota?.vigenciaHasta),
      tipo: new FormControl(tipoNota),
      idCategoriaEvento: new FormControl(this.nota?.idCategoriaEvento),
      informacion: new FormGroup({
        contacto: new FormControl(
          this.nota?.informacion?.contacto,
          tipoNota === 'Contacto' ? Validators.required : null,
        ),
        telefono: new FormControl(this.nota?.informacion?.telefono),
        interno: new FormControl(this.nota?.informacion?.interno),
        email: new FormControl(this.nota?.informacion?.email),
        palabraSeguridadNormal: new FormControl(
          this.nota?.informacion?.palabraSeguridadNormal,
        ),
        palabraSeguridadEmergencia: new FormControl(
          this.nota?.informacion?.palabraSeguridadEmergencia,
        ),
        particion: new FormControl(this.nota?.informacion?.particion, [
          Validators.pattern('^[0-9]*$'),
        ]),
        nota: new FormControl(
          this.nota?.informacion?.nota,
          tipoNota === 'Nota' ? Validators.required : null,
        ),
        numeroUsuarioAlarma: new FormControl(
          this.nota?.informacion?.numeroUsuarioAlarma,
        ),
      }),
      inhabilitadoDesde: new FormControl(this.nota?.inhabilitadoDesde),
      inhabilitadoHasta: new FormControl(this.nota?.inhabilitadoHasta),
    });
  }

  //
  public async onSubmit() {
    this.dialogRef.close(this.form);
  }

  async ngOnInit() {
    this.loading = true;
    if (this.data.form) {
      this.editar = true;
      this.form = this.data?.form;
    } else {
      this.editar = false;
    }
    this.tipo = this.data?.tipo ? this.data?.tipo : 'Contacto';
    this.tipoAsignado = '';
    if (this.editar && this.data.tipo === 'Contacto') {
      this.title = 'Editar Contacto';
      this.contacto = true;
      this.usuario = true;
    } else if (this.editar && this.data.tipo === 'Nota') {
      this.title = 'Editar Nota';
    } else {
      if (this.data.tipo === 'Nota') this.title = 'Crear Nota';
      if (this.data.tipo === 'Contacto') this.title = 'Crear Contacto';
      this.createForm();
    }
    await this.listarCategoriasEvento();
    this.loading = false;
  }
}
